export const FILE_PREVIEW_LOADING = 'FILE_PREVIEW_LOADING';
export const FILE_PREVIEW_SHOW = 'FILE_PREVIEW_SHOW';
export const FILE_PREVIEW_HIDE = 'FILE_PREVIEW_HIDE';
export const FILE_PREVIEW_OPEN = 'FILE_PREVIEW_OPEN';
export const FILE_PREVIEW_RESET = 'FILE_PREVIEW_RESET';

export const REQUEST_URL = '/api/common/pdf';
